module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/sy-9d13beb594ee208a68642569e115b3ff.svg";